module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-white-3-2b62b7f7b62b155c46110583719efe69.webp";